let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5yU7b")).then(() => parcelRequire('fecYF'));